import axios from 'axios';
import { Notify, Dialog } from 'vant';
import store from '@/store';
import { getToken } from '@/utils/storage';
import DOMAINS from '@/utils/environment.js';
import qs from 'qs';

// 创建axios实例
const service = axios.create({
  baseURL: DOMAINS.BASE_API, // api 的 base_url
  timeout: 1000 * 60 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  config => {
    // 设置浏览器不缓存
    config.headers['Cache-Control'] = 'no-cache';
    config.headers['Pragma'] = 'no-cache';
    // 设置请求数据格式
    config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json;charset=UTF-8';
    if (store.getters.token) {
      const Token = getToken();
      config.headers['Authorization'] = `${Token}`;
    }
    if (config.method === 'post') {
      // 如果为post请求，要求Content-Type为json时，数据需要转换成JSON字符串
      if (config.headers['Content-Type'] === 'application/json;charset=UTF-8') {
        config.data = JSON.stringify(config.data);
      } else {
        // 如果是FormData参数据不需要qs序列化处理，否则默认Content-Type数据格式都需要qs序列化处理
        if (!(config.data instanceof FormData)) {
          config.data = qs.stringify(config.data);
        }
      }
    }
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// response 拦截器
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code !== '0') {
      if (res.code === '401') {
        Dialog.alert({
          title: '提示',
          message: '登录已失效，请重新登录！'
        }).then(() => {
          // store.dispatch('RefreshToken');
          store.dispatch('FedLogOut').then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        });
      } else {
        if (response.config.params && response.config.params.export && res && !res.failed) {
          // 如果是导出，response.data返回为乱码则不判断
          return response.data;
        }
        // if (response.config.data) {
        //   // 如果是导出excel
        //   return response;
        // }
        // 如果需要自定义对错误做处理
        if (response.config.data && response.config.data.indexOf('custom') > -1) {
          return response.data;
        }
        // 统一处理错误信息
        Notify({ type: 'danger', message: res.message });
      }
      return Promise.reject(response);
    } else {
      return response.data;
    }
  },
  error => {
    console.log('err' + error); // for debug
    if (error.message.includes('timeout')) { // 判断请求异常信息中是否含有超时timeout字符串
      Notify({ type: 'danger', message: '请求超时' });
    } else if (error.response) {
      switch (error.response.status) {
        case 200:

          break;
        case 401:
          break;
        case 403:
        case 404:
        case 500:
          break;
        default:
          break;
      }
    }
    return Promise.reject(error.response);
  }
);

export default service;
